export default "__VITE_ASSET__BTYzfE5F__"